import React from "react";

interface DiscountBadgeProps {
    isActive: boolean,
    discountAmount: number,
}

function DiscountBadge({isActive, discountAmount}: DiscountBadgeProps) {
    const style = !isActive ? {opacity: 0.3} : {}

    return (
        <span className="gb--badge-red" style={style}>
            {`${discountAmount}% off`}
        </span>
    )
}

export default DiscountBadge